import PropTypes from 'prop-types';
import React from 'react';

import { Map, Iterable, List } from 'immutable';

import Grid             from '@mui/material/Grid';
import Radio            from '@mui/material/Radio';
import RadioGroup       from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl      from '@mui/material/FormControl';
import Linkify          from 'components/Generic/Linkify';

function MultipleChoice({ ...props }) {
  function onSelect(value) {
    props.onChange(props.name, new Map({ text: value }));
  }

  return (
    <Grid item xs={12} sx={{ mt: 1, ml: 2 }}>
      <FormControl component="fieldset">
        <RadioGroup
          aria-label="site"
          name="radio-buttons-group"
          onChange={(e) => onSelect(e.target.value)}
          value={props.value && props.value.get('value')}
          sx={{
            '.MuiButtonBase-root': {
              py: '5px'
            }
          }}
        >
          {
            props.options.map((option) => <FormControlLabel key={option} value={option} control={<Radio color="primary" />} label={<Linkify>{option}</Linkify>} />)
          }
        </RadioGroup>
      </FormControl>
    </Grid>
  );
}

MultipleChoice.defaultProps = {
  value:    null,
  name:     null,
  onChange: null,
  options:  new List(),
};

MultipleChoice.propTypes = {
  value:    PropTypes.objectOf(Iterable),
  name:     PropTypes.string,
  onChange: PropTypes.func,
  options:  PropTypes.objectOf(Iterable),
};

export default MultipleChoice;
